import css from '../Form.module.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DataTestId from 'meta/dataTestId'

import { useFormContext } from '..'

interface Props {
  labelSubmit?: string
}

const FormButtonSubmit: React.FC<Props> = ({ labelSubmit = 'form:send' }) => {
  const { t } = useTranslation()
  const formContext = useFormContext()
  const { submitForm, errors } = formContext

  const [sentAlready, setSentAlready] = useState<boolean>(false)

  const doSubmitForm = () => {
    const areThereErrors = errors && Object.keys(errors).length > 0

    if (!sentAlready && !areThereErrors) {
      submitForm()
      setSentAlready(true)
    }
  }

  useEffect(() => {
    if (sentAlready) {
      const timer = setTimeout(() => {
        setSentAlready(false)
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [sentAlready])

  return (
    <div className={css.form__buttonBar} datatype="form-buttonbar">
      <div
        onClick={doSubmitForm}
        data-testid={DataTestId.form.btnSubmit}
        id="submit"
        className={css.form__buttonSubmit}
      >
        {t(labelSubmit)}
      </div>
    </div>
  )
}

export default FormButtonSubmit
